'use client';
import React from 'react';
import { getFormattedSeasonDatesForPark } from '../../utils/parks/formatters';
import { getHostname, internationaliseContactNumber, sanitiseContactNumber, } from '../../utils/stringUtils';
import { Button, Size, Theme } from '../Button';
import styles from './parkMap.module.scss';
export const createDirectionsUrl = (latlng) => {
    var _a;
    if (!latlng)
        return '';
    const platform = (typeof navigator !== 'undefined' && ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.userAgentData) === null || _a === void 0 ? void 0 : _a.platform)) || null;
    return platform && !!/iPhone|iPod|iPad/.exec(platform)
        ? `maps://maps.google.com/maps?daddr=${latlng}&amp;ll=`
        : `https://maps.google.com/maps?daddr=${latlng}&amp;ll=`;
};
export const ParkMap = ({ parkName, address, contactNumber, mapImage, ukMapImage, pdfUrl, latlng, directionsUrl = createDirectionsUrl(latlng), analytics, seasons, }) => {
    const seasonDates = getFormattedSeasonDatesForPark(seasons);
    const onDownloadMap = () => {
        window === null || window === void 0 ? void 0 : window.open(pdfUrl, '_blank');
    };
    const onGetDirections = () => {
        analytics === null || analytics === void 0 ? void 0 : analytics({
            event: 'visitor interaction',
            interactionName: 'get directions',
            linkHostname: getHostname(directionsUrl),
            linkUrl: directionsUrl,
        });
    };
    const onContactNumberPress = () => {
        analytics === null || analytics === void 0 ? void 0 : analytics({
            event: 'visitor interaction',
            interactionName: 'click to call',
            phoneNumber: sanitiseContactNumber(contactNumber),
        });
    };
    const strippedContactNumber = internationaliseContactNumber(contactNumber);
    return (<div className={styles.parkMap}>
      <a href={directionsUrl} className={styles.parkMapVector} onClick={onGetDirections} target='_blank' rel='noreferrer'>
        <img src={ukMapImage} alt={`UK map highlighting ${parkName}`}/>
      </a>
      <div className={styles.parkMapInfo}>
        <div>
          <h3 className={styles.parkMapHeading}>Opening Dates</h3>
          {(seasonDates === null || seasonDates === void 0 ? void 0 : seasonDates.length)
            ? seasonDates === null || seasonDates === void 0 ? void 0 : seasonDates.map((season) => <div key={season}>{season}</div>)
            : null}
        </div>
        <div>
          {contactNumber ? (<>
              <h3 className={styles.parkMapHeading}>Enquiries</h3>
              <a onClick={onContactNumberPress} href={`tel:${strippedContactNumber}`} className={styles.contactNumber}>
                {contactNumber}
              </a>
            </>) : null}
        </div>
        <div>
          <h3 className={styles.parkMapHeading}>Address</h3>
          <div className={styles.parkMapAddress} dangerouslySetInnerHTML={{
            __html: address,
        }}/>
          {directionsUrl ? (<div className={styles.parkMapAction}>
              <Button useAnchor target='_blank' href={directionsUrl} theme={Theme.SECONDARY_THEME} scale={Size.MEDIUM_SIZE} block onClick={onGetDirections}>
                Get Directions
              </Button>
            </div>) : null}
        </div>
        {mapImage ? (<div>
            <h3 className={styles.parkMapHeading}>Map</h3>
            <button type='button' className={styles.parkMapSiteMap} onClick={onDownloadMap}>
              <img src={mapImage} alt={`Map of ${parkName}`} width={260} height={200} loading='lazy'/>
            </button>
            <div className={styles.parkMapAction}>
              <Button theme={Theme.SECONDARY_THEME} scale={Size.MEDIUM_SIZE} block onClick={onDownloadMap}>
                Download Map
              </Button>
            </div>
          </div>) : null}
      </div>
    </div>);
};
